import { render, staticRenderFns } from "./ValidationSign.vue?vue&type=template&id=d960d87e&scoped=true"
import script from "./ValidationSign.vue?vue&type=script&lang=js"
export * from "./ValidationSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d960d87e",
  null
  
)

export default component.exports